import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './ResetPasswordForm.jsx'

export default createSubmit(name)